/// <reference path="../../_references.ts"/>

module App.History {
	import TitleBarService = App.Helpers.TitleBarService;
	import ServiceRequest = App.Customer.ServiceRequest;
	import SelectedAppointment = App.Appointments.SelectedAppointment;
	import AppRootScope = App.Administrative.AppRootScope;
	import OfficeService = App.Utils.OfficeService;

	export class ServiceRequestDetailController {
		static $inject: string[] = ['$rootScope', '$state' ,'TitleBarService', 'HistoryService', 'OfficeService', '$stateParams', '$window'];

		serviceRequest: ServiceRequest;
		invoice: string;
		hasInvoice: boolean = true;
		fromOffice: boolean = false;

		constructor(
			private $rootScope: AppRootScope,
			private $state: ng.ui.IStateService,
			private TitleBarService: TitleBarService,
			private HistoryService: HistoryService,
			private OfficeService: OfficeService,
			private $stateParams: ng.ui.IStateParamsService,
			private $window: ng.IWindowService
		) {
			TitleBarService.set('History');
			this.$rootScope.app.startAppLoading();

			OfficeService.getAppointment()
				.then(() => this.fromOffice = true)
				.finally(() => this.initialize());
		}

		initialize() {
			if (this.$stateParams.id) {
				this.HistoryService.getServiceRequest(this.$stateParams.id).then((response) => {
					this.serviceRequest = response.data;

					if(this.serviceRequest.latest_invoice_id) {
						this.getInvoice(this.serviceRequest.latest_invoice_id);
					} else {
						this.hasInvoice = false;
						this.$rootScope.app.stopAppLoading();
					}
				});
			} else {
				this.$state.go('zipSolutions.history.servicerequest');
				this.$rootScope.app.stopAppLoading();
			}
		}

		goBack() {
			if (!this.fromOffice) {
				this.$window.history.back();
			} else {
				this.$state.go('zipSolutions.history.servicerequest');
			}
		}

		getInvoice(invoiceId: number) {
			this.HistoryService.getInvoiceHtml(invoiceId).then((response) => {
				let parser = new DOMParser(),
					body = parser.parseFromString(response.data, 'text/html'),
					removal: Element[] = [].concat(
						Array.from(body.getElementsByClassName('page-header')),
						Array.from(body.getElementsByTagName('script'))
					);

				removal.forEach((e) => {
					try {
						e.parentNode.removeChild(e);
					} catch (e) {
						// Ignore any errors
					}
				});

				this.invoice = body.body.innerHTML;
				this.$rootScope.app.stopAppLoading();
			});
		}
	}
}
